import { Box, Button } from '@material-ui/core';
import { MerchantStructure } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Font } from '../../../../../shared/components/Font';
import { Text } from '../../../../../shared/components/Text';

interface ChannelFooterProps {
  editModeAllowed: boolean;
  onAddChannel: () => void;
  merchantStructure: MerchantStructure;
}

export const ChannelFooter = ({ editModeAllowed, onAddChannel, merchantStructure }: ChannelFooterProps) => {
  return (
    <Box mt={2} pr={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
      <div>
        {editModeAllowed && (
          <Button
            size={'small'}
            variant={'text'}
            onClick={onAddChannel}
            startIcon={<i className="material-icons-outlined">add</i>}
          >
            <Font variant={'body2'} color={'textSecondary'}>
              <Text tId={'ADD_CHANNEL'} />
            </Font>
          </Button>
        )}
      </div>
      <Font variant={'body2'} color={'textSecondary'}>
        <Text
          tId={merchantStructure.merchant.channels.length === 1 ? 'NUMBER_OF_CHANNEL_1' : 'NUMBER_OF_CHANNELS'}
          dynamicDataTexts={[merchantStructure.merchant.channels.length.toFixed(0)]}
        />
      </Font>
    </Box>
  );
};
